export default function CustomerList(){
    return (<>Customers</>)
}